var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('NavBar'),_c('AboutHero'),_c('OurStory'),_c('OurValues'),_c('FooterPage')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }